import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';

const AddDechargement = ({ onClose }) => {
    const [loading, setLoading] = useState(false);
    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [caisses, setCaisses] = useState([]);
    const [selectedCaisse, setSelectedCaisse] = useState(null);
    const [inputValueCaisse, setValueCaisse] = useState('');
    const [preuve, setPreuve] = useState();
    const [dechargement, setDechargement] = useState({
        dateDechargement:'',
        montant: 0,
        numOrdre: '',
        responsable: '',
        reference: '',
        note: '',
        caisse: '',

    });

    const handleInputChangeCaisse = value => {
        setValueCaisse(value);
    };

    // handle selection


    // handle selection
    const handleChangeCaisse = value => {
        setSelectedCaisse(value);
        setDechargement({ ...dechargement, caisse: value.id });

    }

    const getCaisses = () => {
        axiosClient.get('/softCaisses')
            .then((data) => {
                setCaisses(data.data.caisses);
            })
    }
    function handleChangeFile(event) {
        setPreuve(event.target.files[0]);

    }

    useEffect(() => {
        getCaisses();
    }, []);


    const navigate = useNavigate();

    const onSubmit = () => {

        setErrors(null);
        setLoading(true);
        const formData = new FormData();
        formData.append('note', dechargement.note);
        formData.append('montant', dechargement.montant);
        formData.append('reference', dechargement.reference);
        formData.append('responsable', dechargement.responsable);
        formData.append('source', dechargement.source);
        formData.append('dateDechargement', dechargement.dateDechargement);
        formData.append('montant', dechargement.montant);
        formData.append('caisse', dechargement.caisse);
        formData.append('numOrdre', dechargement.numOrdre);
        formData.append('preuve', preuve);
        axiosClient.post('/dechargement/save', formData)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header title="Ajouter un déchargement" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className="flex gap-2">
                                        <div className="flex-col">
                                            
                                            <div className='flex-col w-full justify-evenly '>
                                            <div className='mr-2'>
                                                <Input label="Date" type="date" value={dechargement.dateDechargement} onChange={ev => setDechargement({ ...dechargement, dateDechargement: ev.target.value })} required="required"/>
                                                </div>
                                                <div className="flex-col w-full">
                                                    <label className="block text-sm font-medium leading-6 text-gray-900">Caisse <span className='text-red-500'> *</span></label>
                                                    <Select className='mt-2 outline-1 ' placeholder="Caisse" cacheOptions defaultOptions value={selectedCaisse} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={caisses} onInputChange={handleInputChangeCaisse} onChange={handleChangeCaisse} />
                                                </div>
                                            </div>
                                            <div className='mr-2'>
                                                <Input label="Montant" type="number" value={dechargement.montant} onChange={ev => setDechargement({ ...dechargement, montant: ev.target.value })} required="required"/>
                                            </div>
                                            <div className='mr-2'>
                                                <Input label="Responsable" type="text" value={dechargement.responsable} onChange={ev => setDechargement({ ...dechargement, responsable: ev.target.value })} required="required" />
                                            </div>
                                            <div className='mr-2'>
                                                <Input label="Numero ordre" type="text" value={dechargement.numOrdre} onChange={ev => setDechargement({ ...dechargement, numOrdre: ev.target.value })} required="required" />
                                            </div>
                                        </div>
                                        <div className="flex-col">
                                            
                                            <div className='mr-2'>
                                                <Input label="Reference" type="text" value={dechargement.reference} onChange={ev => setDechargement({ ...dechargement, reference: ev.target.value })} required="required" />
                                            </div>
                                            <div className='mr-2'>
                                                <Input label="Preuve" type="file" onChange={handleChangeFile} required="required" />
                                            </div>
                                            <div className='mr-2'>
                                                <Input label="Note" type="text" value={dechargement.note} onChange={ev => setDechargement({ ...dechargement, note: ev.target.value })} required="required" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            {loading ? <Loading /> :
                                <div className=' flex gap-3 m-2  justify-between'>
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                    <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddDechargement